import { ApiService } from "../../../constants/ApiService";
import { HttpService } from "../../../constants/HTTPService";
import { NewIDataUploadItem } from "../../../interfaces/IDataUploadItem";
import { IForm } from "../../../interfaces/IForm";

export const getUserTesting = async () => {
  const data = HttpService.get(ApiService.testing.getTestingUser);
  const dataAPI = (await data).data;

  return dataAPI.data;
};

export const getListRequestType = async () => {
  const data = HttpService.get(ApiService.alesaForm.getListRequestType);
  const dataAPI = (await data).data;

  return dataAPI.data;
};

export const getListDocumentType = async () => {
  const data = HttpService.get(ApiService.alesaForm.getListDocumentType);
  const dataAPI = (await data).data;

  return dataAPI.data;
};

export const getListAreaLocation = async () => {
  const data = HttpService.post(
    ApiService.apiHc.getAreaLocation,
    JSON.stringify({
      AreaLocation: { LocationID: "", LocationHierarcyID: "" },
    })
  );
  const dataAPI = (await data).data;

  return dataAPI.data;
};

export const InsertForm = async (
  dataForm?: IForm,
  dataUpload?: NewIDataUploadItem[],
  requestStatusID?: string,
  crrNumber?: string
) => {
  function convertData(inputData: NewIDataUploadItem[]) {
    return inputData.reduce((acc: any[], curr) => {
      const files = curr.files.map((file) => ({
        title: curr.title,
        fileType: curr.fileType,
        ...file,
      }));
      return [...acc, ...files];
    }, []);
  }
  const files = convertData(dataUpload || []);
  const data = HttpService.post(
    ApiService.alesaForm.insertForm,
    JSON.stringify({
      CrrNumber: crrNumber,
      StartDateString: dataForm?.startDatePeriod,
      EndDateString: dataForm?.endDatePeriod,
      RequestDate: dataForm?.requestDate,
      POADate: dataForm?.dateOfPower,
      BinusianID: dataForm?.binusianID,
      BinusianName: dataForm?.binusianName,
      TitleAgreement: dataForm?.titleAgreement,
      Counterpart: dataForm?.counterPart,
      Signer: `${dataForm?.signer?.binusianIDEmail}#${dataForm?.signer?.name}`,
      DocumentTypeID: dataForm?.documentType,
      RequestTypeID: dataForm?.requestType,
      Area: dataForm?.area,
      DetailArea: dataForm?.address,
      ListDocument: files,
      RequestStatusID: requestStatusID,
      Ext: dataForm?.extension,
    })
  );
  const dataAPI = (await data).data;
  return dataAPI;
};

export const getSingleDataRequest = async (requestID?: string) => {
  const data = HttpService.post(
    ApiService.alesaForm.getSingleDataRequest,
    JSON.stringify({
      RequestID: requestID,
    })
  );
  const dataAPI = (await data).data;

  return dataAPI.data;
};
